module.exports = __webpack_public_path__ + "static/media/icon-pricing.14ff0139.svg";